export default __webpack_public_path__ + "static/media/mike-swigunski-k9Zeq6EH_bk-unsplash.3a8ac26e.jpg";